const EXCLUDED_ROOM_CATEGORIES = ['Superior Room'];

export const isVisibleRoomCategory = (room) =>
  !EXCLUDED_ROOM_CATEGORIES.includes(room?.name);
